
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/faq",
      function () {
        return require("private-next-pages/[lang]/faq.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/faq"])
      });
    }
  